import React from 'react';
import classNames from 'classnames';

const RegistrationNoticeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="template-modal-overlay" onClick={handleOverlayClick}>
      <div className="template-modal">
        <button className="template-modal__close" onClick={onClose}>
          <i className="fi fi-close"></i>
        </button>

        <div className="template-modal__content">
          <h2 className="template-modal__title">{i18n.t('after_registration.title')}</h2>

          <div className="template-modal__list-wrapper">
            <p className="template-modal__list-text">{i18n.t('after_registration.list_text')}</p>
            <ul className="template-modal__list">
              <li className="template-modal__list-item">{i18n.t('after_registration.list_item_text_1')}</li>
              <li className="template-modal__list-item">{i18n.t('after_registration.list_item_text_2')}</li>
              <li className="template-modal__list-item">{i18n.t('after_registration.list_item_text_3')}</li>
              <li className="template-modal__list-item">{i18n.t('after_registration.list_item_text_4')}</li>
            </ul>
          </div>

          <div className="template-modal__actions">
            <button className="btn btn-success-inverse" onClick={onClose}>
              {i18n.t('cancel')}
            </button>
            <a href="/sign_up?utm_source=demo-builder" className="btn btn-success">
              {i18n.t('after_registration.registration')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationNoticeModal;
